// The certified POA as the lawyer files it with Finanças: the Ordem's
// certification, the POA it certifies and the audit log, one PDF named after
// the customer. Apart from "Download PDF", which stays the whole case.

import React, { useState } from 'react';
import { User } from 'firebase/auth';
import { PoaCertification, downloadCertifiedPoa } from '../../api/certifications';
import { certificationState } from './PoaCertificationPanel';

export interface CertifiedPoaDownloadButtonProps {
  caseId: string;
  /** The id of the newest signed POA file on the case. */
  poaFileId: string;
  certification?: PoaCertification | null;
  user: User | null;
}

const CertifiedPoaDownloadButton: React.FC<CertifiedPoaDownloadButtonProps> = ({
  caseId,
  poaFileId,
  certification,
  user,
}) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const certified = certificationState(certification, poaFileId) === 'certified';

  const download = async () => {
    if (!user) return;
    setBusy(true);
    setError('');
    try {
      const { blob, fileName } = await downloadCertifiedPoa(await user.getIdToken(), caseId);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      setError(err.message || 'Could not download the certified POA.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="download-all-btn"
        onClick={download}
        disabled={!certified || busy}
        title={certified ? 'Certification, POA and audit log in one PDF' : 'Waiting for the certification'}
      >
        {busy ? 'Preparing…' : 'Download certified POA'}
      </button>
      {error && <div className="financas-office-error" role="alert">{error}</div>}
    </>
  );
};

export default CertifiedPoaDownloadButton;
